module.exports = __webpack_public_path__ + "img/designer_pass.22a2f2cb.png";